export enum RegisterFormKeys {
    Name = 'register-name',
    Surname = 'register-surname',
    Patronymic = 'register-patronymic',
    CompanyINN = 'register-company-inn',
    JobTitle = 'register-job-title',
    Department = 'register-department',
    Email = 'register-email',
    Phone = 'register-phone',
    AgreementAdvert = 'register-agreement-advert',
}

export const REQUEST_EMAIL_TIMER_KEY = 'request-email-timer';
